import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA({
  anchorId
}: {
  anchorId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById(anchorId);
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled out of view upwards.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, [anchorId]);
  return <div className={['fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out', visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'].join(' ')} data-id="element-157" data-mp="2ft3cst7pxoes">
      <div className="mx-auto max-w-lg" data-id="element-158" data-mp="33jqmnk172o3z">
        <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-gogreen-500 px-4 py-4 text-center text-[14px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-colors duration-150 ease-out hover:bg-gogreen-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base" data-id="element-159" data-mp="33iny3ircgxr8">
          Get the Blueprint — $27
        </a>
      </div>
    </div>;
}